import React, { useState, useEffect } from "react"
import { useParams, Redirect } from 'react-router-dom';
import SpinnerCard from '../../SpinnerCard';
import NavBar from './NavBar';

function VerifyLogin(props) {

    let [loggedIn, setLoggedIn] = useState();
    const { licenseName } = useParams();
    var [license] = useState(licenseName);

    // Set props.onLoginVerified to callback for when the verification
    // was successful and you want to start running useEffects() in dependent
    // components

    function setLoginStatus(status) {
        let success = status === 200 ? true : false;
        setLoggedIn(success);
        if (props.onLoginVerified !== undefined && success) props.onLoginVerified();
    }

    useEffect(() => {
        const verify = async () => {
            const query = `/api/${license}/login/verify`;
            const res = await fetch(query,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    mode: 'cors',
                    cache: 'no-store'
                });
            setLoginStatus(res.status);
        }
        verify();
        // eslint-disable-next-line
    }, [license]);

    if (loggedIn === undefined) {
        return <SpinnerCard></SpinnerCard>;
    }
    else if (loggedIn) {
        return (
            <React.Fragment>
                <NavBar />
                {props.children}
            </React.Fragment>
        );
    }
    else {
        var target = `/${license}/login`;
        return (
            <Redirect to={target} />
        );
    }

}

export default VerifyLogin;